<template>
  <modal name="mapLocationBoardModal" ref="refMapLocationBoardModal"
         :width="this.modalWidth"
         :height="this.modalHeight"
         :draggable="!this.isMobile"
         :resizable="false"
         :reset="true"
         :scrollable="true"
         :clickToClose="false"
         :adaptive="true"
         :shiftX="this.modalShiftX"
         :shiftY="this.modalShiftY"
         @opened="eventModelOpen">
    <div id="layer-popup">
      <div class="popup-header">
        <h2>{{ areaName }} 위치보드</h2>
        <button type="button" class="popup-close" @click="this.closeMapLocationBoard">
          <img src="../assets/web/images/icon_popup_close.png" alt="팝업닫기" title="팝업닫기">
        </button>
      </div>
      <div class="popup-cnt">
        <div class="graph01" ref="locationMap" id="map" :style="{width: mapWidth+'px', height: mapHeight+'px'}">
          <!--          <div class="graph01" id="map" style="width: 760px; height: 300px;">-->
        </div>
        <div class="graph02">
          <Grid ref="locationBoardGrid"
                :theme="locationBoardGrid.gridTheme"
                :options="locationBoardGrid.options"
                :data="locationBoardGrid.data"
                :columns="locationBoardGrid.columns"
                @click="eventGridClick"/>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import 'tui-grid/dist/tui-grid.css'
import { Grid } from '@toast-ui/vue-grid'
import { eventBus } from '@/event-bus'
import { mapGetters } from 'vuex'
import mapApi from '@/api/web/MapApi'
import GridOption from "@/assets/js/gridOption"
import commonUI from '@/mixin/commonUI'

const statItemStore = 'statItemStore'

export default {
  name: 'MapLocationBoard',
  components: {
    Grid
  },
  mixins: [commonUI],
  data () {
    return {
      modalWidth: 800,
      modalHeight: 700,
      mapWidth: 760,
      mapHeight: 300,
      map: undefined,
      areaName: '',
      areaCd: '',
      srcNo: '',
      mapZoomLevel: 12,
      isShowMapMarkerOverlay: false,
      mapLocationItems: [],
      mapMarkers: [],
      mapMarkerOverlay: [],
      locationBoardGrid: {},
    }
  },
  computed: {
    ...mapGetters(statItemStore, {
      selectedStatItems: 'selectedStatItems',
    }),

    modalShiftX () {
      if (this.isMobile) {
        return 0.5
      }
      return 0.97
    },

    modalShiftY () {
      if (this.isMobile) {
        return 0.5
      }
      return 0.7
    },
  },
  created () {
    // 그리드 옵션 설정
    this.locationBoardGrid = GridOption.locationBoardGridOption()

    if (this.isMobile) {
      this.modalWidth = window.innerWidth
      this.modalHeight = window.innerHeight

      // 모달 콘텐츠 높이 = (모달 세로 높이 - (모달 헤더 - padding(위/아래) - 차트 그리드 중간 공간) / 2)
      const modalContents = (this.modalHeight - 55 - 18 - 18 - 12) / 2

      this.mapWidth = this.modalWidth - 18 - 18 - 4
      this.mapHeight = modalContents

      this.locationBoardGrid.options.bodyHeight = modalContents - this.locationBoardGrid.options.header.height
    }

    eventBus.$on('closeMapLocationBoard', () => {
      this.closeMapLocationBoard()
    })

    eventBus.$on('showMapLocationBoard', (areaName, areaCd) => {
      this.areaName = areaName
      this.areaCd = areaCd

      for (const marker of this.mapMarkers) {
        marker.setMap(null)
      }

      this.srcNo = ''
      this.mapLocationItems = []
      this.mapMarkers = []

      for (const statItem of this.selectedStatItems) {
        if (statItem.srcCd === '2' && statItem.srcNo) {
          this.srcNo = statItem.srcNo
          this.mapLocationItems.push(statItem.info.mapItmNm)
        }
      }
      if (this.srcNo === '' && this.mapLocationItems.length === 0) {
        this.closeMapLocationBoard()
      } else {
        const container = document.getElementById('map')
        if (container) {
          this.searchMapLocationData()
        } else {
          this.$modal.show('mapLocationBoardModal')
        }
      }
    })

    eventBus.$on('sendMapLocationBoard', () => {
      if (this.areaName === '' && this.areaCd === '') {
        return
      }

      eventBus.$emit('showMapLocationBoard', this.areaName, this.areaCd)
    })
  },

  mounted () {
  },

  beforeDestroy () {
    this.closeMapLocationBoard()
  },

  methods: {
    eventModelOpen (event) {
      window.kakao && window.kakao.maps ? this.initMap() : this.addScript()
    },

    addScript () {
      const script = document.createElement('script')
      script.onload = () => window.kakao.maps.load(this.initMap)
      script.src = '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=bdec0539e6ac9935d4c7fc99833f6780'
      document.head.appendChild(script)
    },

    initMap () {
      const container = document.getElementById('map')

      const options = { center: new window.kakao.maps.LatLng(37.56631769, 126.9778284), level: this.mapZoomLevel }
      this.map = new window.kakao.maps.Map(container, options)

      // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다
      const mapTypeControl = new window.kakao.maps.MapTypeControl()

      // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
      // daum.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다
      this.map.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT)

      // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
      const zoomControl = new window.kakao.maps.ZoomControl()
      this.map.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT)

      window.kakao.maps.event.addListener(this.map, 'zoom_changed', () => {
        if (this.mapMarkerOverlay) {
          this.mapZoomLevel = this.map.getLevel()

          if (this.mapZoomLevel < 11) {
            this.isShowMapMarkerOverlay = true
          } else {
            this.isShowMapMarkerOverlay = false
          }

          for (const overlay of this.mapMarkerOverlay) {
            overlay.setVisible(this.isShowMapMarkerOverlay)
          }
        }
      })

      this.searchMapLocationData()
    },

    searchMapLocationData () {
      const params = {
        srcNo: this.srcNo,
        sido: this.areaName,
        mapItmNms: this.mapLocationItems
      }

      mapApi.searchLocationBoard(params).then(resultData => {
        this.locationBoardGrid.data = resultData
        this.$refs.locationBoardGrid.invoke('resetData', resultData)
        this.showMapLocationMaker(resultData)
      })
    },

    showMapLocationMaker (locationData) {
      if (locationData) {
        const imageSrc = 'https://i1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png'
        const imageSize = new window.kakao.maps.Size(36, 36)
        const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize)

        const bounds = new window.kakao.maps.LatLngBounds()

        this.mapMarkers = []
        this.mapMarkerOverlay = []

        for (let idx = 0; idx < locationData.length; idx++) {
          const latlng = new window.kakao.maps.LatLng(locationData[idx].latitude, locationData[idx].longitude)
          bounds.extend(latlng)

          const marker = this.createMaker(locationData[idx].name, latlng, markerImage)
          this.mapMarkers.push(marker)

          const titleOverlay = this.createTitleOverlay(locationData[idx].name, latlng)
          this.mapMarkerOverlay.push(titleOverlay)

          window.kakao.maps.event.addListener(marker, 'click', () => {
            this.findGridRowFocus(locationData[idx])
            this.eventMapMarkerClick(marker)
          })

          window.kakao.maps.event.addListener(marker, 'mouseover', () => {
            titleOverlay.setVisible(true)

          })
          window.kakao.maps.event.addListener(marker, 'mouseout', () => {
            titleOverlay.setVisible(this.isShowMapMarkerOverlay)
          })
        }
        this.map.setBounds(bounds)
      }
    },

    createMaker (title, location, markerImage) {
      return new window.kakao.maps.Marker({
        map: this.map,
        position: location,
        title: title,
        image: markerImage,
      })
    },

    createTitleOverlay (title, location) {
      return new window.kakao.maps.CustomOverlay({
        map: this.map,
        position: location,
        content: '<div class="customOverlay"><span class="title">' + title + '</span>',
        clickable: false,
        xAnchor: 0.5,
        yAnchor: 0.2,
        zIndex: 3,
        title: title
      })
    },

    closeMapLocationBoard () {
      this.areaName = ''
      this.areaCd = ''
      this.srcNo = ''
      this.mapLocationItems = []
      this.$modal.hide('mapLocationBoardModal')
    },

    eventMapMarkerClick (marker) {
      this.map.setLevel(9)
      this.map.setCenter(marker.getPosition())
    },

    eventGridClick (evt) {
      const rowData = this.$refs.locationBoardGrid.invoke('getRow', evt.rowKey)

      if (rowData){
        if (evt.columnName === 'url') {
          if (this.checkUrl(rowData.url)) {
            window.open(rowData.url, '_blank')
          }
        } else {
          for (const mapMarker of this.mapMarkers) {
            if (rowData.name === mapMarker.getTitle()) {
              this.eventMapMarkerClick(mapMarker)
            }
          }

        }
      }
    },

    checkUrl (url) {
      const regex = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\\/]))?/
      return regex.test(url)
    },

    findGridRowFocus(data) {
      const findGridRowDataList = this.$refs.locationBoardGrid.invoke('findRows', {
        name: data.name
      })

      for (let findGridRowData of findGridRowDataList) {
        this.$refs.locationBoardGrid.invoke('setSelectionRange', {
          start: [findGridRowData.rowKey],
          end: [findGridRowData.rowKey]
        })
        this.$refs.locationBoardGrid.invoke('focus', findGridRowData.rowKey, 'name')
      }
    }
  }
}
</script>

<style scoped>
.vm--container {
  width: 0px;
  height: 0px;
  z-index: 1000;
}
</style>

<style>
.vm--overlay[data-modal="mapLocationBoardModal"] {
  width: 0px;
  height: 0px;
  background: transparent;
}

#map div {
  box-sizing: content-box !important;
}

.customOverlay {position:relative;bottom:77px;border-radius:6px;border: 1px solid #ccc;border-bottom:2px solid #ddd;float:left;}
.customOverlay:nth-of-type(n) {border:0; box-shadow:0px 1px 2px #888;}
/*.customOverlay a {display:block;text-decoration:none;color:#000;text-align:center;border-radius:6px;font-size:14px;font-weight:bold;overflow:hidden;background: #d95050;background: #d95050 url(https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/arrow_white.png) no-repeat right 14px center;}*/
.customOverlay .title {display:block;text-align:center;background:#fff;padding:10px 15px;font-size:14px;font-weight:bold;border-radius:6px}
.customOverlay:after {content:'';position:absolute;margin-left:-12px;left:50%;bottom:-12px;width:22px;height:12px;background:url('https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/vertex_white.png')}
</style>
